<script>
import { TOKEN_SESSION, USER , TOAST_MESSAGE} from "../../stores";
import * as Fx from '../../globals/Fx.js'
import { createEventDispatcher } from "svelte";
import GLOBALS from "../../globals/GLOBALS";

const dispatch = createEventDispatcher();

export let opacity = 0
export let periodo = null

String.prototype.lines = function() { return this.split(/\r*\n/); }
String.prototype.lineCount = function() { return this.lines().length; }

let value = null
let cantConsumos = 0
let totalConsumos = 0

const _analizeData = (texto) => {
    cantConsumos = texto.lineCount()
    totalConsumos = 0
    let r
    texto.lines().forEach((item,idx) => {
        if(item.length > 0){
            r = item.split(/\t|;|:| /)
            totalConsumos += parseFloat(r[1].replace(",","."))
        }
    })
}

const _LIQ_QUERY = async (QUERY, data) => {
    // const data = {};
    const URL = GLOBALS.URL;
    const bearer = "Bearer " + $TOKEN_SESSION;
    await fetch(`${URL}/API/liquidaciones/QUERY/${QUERY}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Authorization: bearer,
            "Content-type": "application/json;charset=UTF-8",
        },
    })
        // Handle success
        .then((response) => response.json()) // convert to json
        .then((json) => {
            if (json.result === "success") {
                switch(QUERY){
                    case "SAVECONSUMOS":
                        if (json.result === "success") {
                            json.message = "Los consumos fueron grabados correctamente!!"
                            dispatch("close")
                        }else{
                        }
                        TOAST_MESSAGE.set(json)
                    break;
                }
            }else{
                TOAST_MESSAGE.set(json)
                if (json.status === 403) TOKEN_SESSION.set(null)
            }
            
        }) //print data to console
        .catch((err) => -console.log("Request Failed", err)); // Catch errors
};

const _saveConsumos = async () => {
    let data = []
    let r
    value.lines().forEach((item,idx) => {
        if(item.length > 0){
            r = item.split(/\t|;|:| /)
            data.push({liq_id_contrato:r[0],liq_csmo_energia:parseFloat(r[1].replace(",","."))})
        }
    })
    await _LIQ_QUERY("SAVECONSUMOS",{periodo,data})
}

const _close = () => {
    dispatch("close")
}

</script>

<div class="consumos-container" style="opacity:{opacity}">
    <h4 class="text-center mt-3 mb-5">Cargar Consumos</h4>
    <p>En esta ventana puedes cargar los consumos correspondientes al periodo seleccionado</p>
    <div class="d-flex flex-row justify-content-center">
        <textarea class="form-control" bind:value on:change={() => _analizeData(value)} 
                  placeholder='Pega aquí los datos del ContratoID y Valor de Consumo($) de los Suscriptores que deseas cargar.  Lo más sencillo es desde Excel crear ambas columnas y copiar y pegar en este lugar. Sin embargo, el formato que deben tener los datos pueden ser los siguiente:&#13;&#13;- Separados por "tabulación" como viene de EXCEL (Ejemplo):&#13;11000873    23085499&#13;11000874    23851200&#13;&#13;- Separados por "espacio" (Ejemplo):&#13;11000873 23085499&#13;11000874 23851200&#13;&#13;- Separados por ";" (Ejemplo):&#13;11000873;23085499&#13;11000874;23851200&#13;&#13;- Separados por ":" (Ejemplo):&#13;11000873:23085499&#13;11000874:23851200'
        ></textarea>
        <div class="d-flex flex-column mx-3">
            <div class="form-control fs-3 mb-1 py-3">Cantidad de Consumos <span class="badge bg-info">{cantConsumos}</span></div>
            <div class="form-control fs-3 mb-1 py-3">Total de Consumo <span class="badge bg-info">{Fx.formatter.format(totalConsumos).cop()}</span></div>
            <div class="btn btn-primary mt-4 mb-1" on:click={() => _saveConsumos()}>Guardar</div>
            <div class="btn btn-danger "  on:click={() => _close()}>Cerrar</div>
        </div>
    </div>
</div>

<style>
    .consumos-container {
        width: 100%;
    }

    textarea {
        resize: vertical;
        min-width: 300px;
        height: 400px;
        padding: 10px;
    }
</style>